import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Delete, Edit } from "@mui/icons-material";
import useAuthStore from "../../../services/AuthStore";

export default function Groups() {
  const { getGroups } = useAuthStore();
  const [groups, setGroups] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentGroup, setCurrentGroup] = useState({
    id: null,
    group_name: "",
    curator_id: "",
    course_number: "",
    proffesion_name: "",
    special_name: "",
    start_year: "",
    end_year: "",
  });
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    getGroups()
      .then(newGroups => {
        setGroups(newGroups);
      })
      .catch(error => {
        console.error("Ошибка при получении групп:", error);
      });
  }, [getGroups]);

  const handleOpenDialog = (
    group = {
      id: null,
      group_name: "",
      curator_id: "",
      course_number: "",
      proffesion_name: "",
      special_name: "",
      start_year: "",
      end_year: "",
    },
  ) => {
    setCurrentGroup(group);
    setIsEditing(!!group.id);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setCurrentGroup({
      id: null,
      group_name: "",
      curator_id: "",
      course_number: "",
      proffesion_name: "",
      special_name: "",
      start_year: "",
      end_year: "",
    });
  };

  const handleSaveGroup = () => {
    if (isEditing) {
      setGroups(prev =>
        prev.map(group =>
          group.id === currentGroup.id ? currentGroup : group,
        ),
      );
    } else {
      setGroups(prev => [
        ...prev,
        { ...currentGroup, id: prev.length ? prev[prev.length - 1].id + 1 : 1 },
      ]);
    }
    handleCloseDialog();
  };

  const handleDeleteGroup = id => {
    setGroups(prev => prev.filter(group => group.id !== id));
  };

  const columns = [
    { field: "id", headerName: "Номер", width: 90 },
    { field: "group_name", headerName: "Название группы", width: 150 },
    { field: "course_number", headerName: "Курс", width: 100 },
    { field: "proffesion_name", headerName: "Профессия", width: 200 },
    { field: "special_name", headerName: "Специальность", width: 200 },
    { field: "start_year", headerName: "Начало об.", width: 100 },
    { field: "end_year", headerName: "Конец об.", width: 100 },
    {
      field: "actions",
      headerName: "Действия",
      width: 200,
      renderCell: params => (
        <Box>
          <Button
            size="small"
            variant="contained"
            onClick={() => handleOpenDialog(params.row)}>
            <Edit />
          </Button>
          <Button
            size="small"
            color="error"
            variant="contained"
            onClick={() => handleDeleteGroup(params.row.id)}
            style={{ marginLeft: 8 }}>
            <Delete />
          </Button>
        </Box>
      ),
    },
  ];

  return (
    <Box>
      <Typography variant="h6" style={{ marginBottom: 16 }}>
        Управление группами
      </Typography>
      <Button
        variant="contained"
        onClick={() => handleOpenDialog()}
        style={{ marginBottom: 16 }}>
        Добавить новую группу
      </Button>
      <Box sx={{ height: 400, width: "100%" }}>
        <DataGrid
          rows={groups}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      </Box>

      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>{isEditing ? "Edit Group" : "Add Group"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Название группы"
            fullWidth
            value={currentGroup.group_name}
            onChange={e =>
              setCurrentGroup({ ...currentGroup, group_name: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="ID куратора"
            fullWidth
            value={currentGroup.curator_id}
            onChange={e =>
              setCurrentGroup({ ...currentGroup, curator_id: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Курс"
            fullWidth
            value={currentGroup.course_number}
            onChange={e =>
              setCurrentGroup({
                ...currentGroup,
                course_number: e.target.value,
              })
            }
          />
          <TextField
            margin="dense"
            label="Профессия"
            fullWidth
            value={currentGroup.proffesion_name}
            onChange={e =>
              setCurrentGroup({
                ...currentGroup,
                proffesion_name: e.target.value,
              })
            }
          />
          <TextField
            margin="dense"
            label="Специальность"
            fullWidth
            value={currentGroup.special_name}
            onChange={e =>
              setCurrentGroup({ ...currentGroup, special_name: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Год начала"
            fullWidth
            value={currentGroup.start_year}
            onChange={e =>
              setCurrentGroup({ ...currentGroup, start_year: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Год окончания"
            fullWidth
            value={currentGroup.end_year}
            onChange={e =>
              setCurrentGroup({ ...currentGroup, end_year: e.target.value })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSaveGroup} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
